module.exports = __webpack_public_path__ + "img/about_video.6039229f.svg";